__turbopack_context__.v({
  "fallback_spacing": "PageTransition-module-scss-module__3E4t1q__fallback_spacing",
  "page_transition": "PageTransition-module-scss-module__3E4t1q__page_transition",
});
